module.exports = require("././ui-map.js");


//////////////////
// WEBPACK FOOTER
// angular-ui-map (bower component)
// module id = 386
// module chunks = 0